
<template>
  <content-loader
    view-box="0 0 400 90"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
  >
    <!-- 2 start -->
    <!-- <rect x="28" y="8" rx="1" ry="1" width="87" height="8" /> 
    <rect x="28" y="28" rx="1" ry="1" width="87" height="8" /> 
    <rect x="0" y="41" rx="5" ry="5" width="400" height="1" /> 
    <rect x="13" y="8" rx="0" ry="0" width="6" height="8" /> 
    <rect x="16" y="9" rx="0" ry="0" width="7" height="7" /> 
    <rect x="16" y="29" rx="0" ry="0" width="7" height="7" /> 
    <rect x="13" y="28" rx="0" ry="0" width="6" height="8" /> 
    <rect x="162" y="8" rx="0" ry="0" width="87" height="8" /> 
    <rect x="298" y="8" rx="1" ry="1" width="87" height="8" /> 
    <rect x="162" y="28" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="28" rx="1" ry="1" width="87" height="8" /> 
    <rect x="0" y="22" rx="5" ry="5" width="400" height="1" /> 
    <rect x="13" y="48" rx="0" ry="0" width="6" height="8" /> 
    <rect x="16" y="49" rx="0" ry="0" width="7" height="7" /> 
    <rect x="0" y="62" rx="5" ry="5" width="400" height="1" /> 
    <rect x="28" y="48" rx="1" ry="1" width="87" height="8" /> 
    <rect x="162" y="48" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="48" rx="1" ry="1" width="87" height="8" /> 
    <rect x="17" y="-2" rx="5" ry="5" width="373" height="1" /> 
    <rect x="17" y="-2" rx="5" ry="5" width="373" height="1" /> 
    <rect x="0" y="1" rx="5" ry="5" width="400" height="1" /> -->
    <!-- 2 end -->

    <!-- loader with table header -->
    <!-- <rect x="28" y="69" rx="1" ry="1" width="87" height="8" /> 
    <rect x="28" y="28" rx="1" ry="1" width="87" height="8" /> 
    <rect x="0" y="41" rx="5" ry="5" width="400" height="1" /> 
    <rect x="13" y="69" rx="0" ry="0" width="6" height="8" /> 
    <rect x="16" y="70" rx="0" ry="0" width="7" height="7" /> 
    <rect x="16" y="29" rx="0" ry="0" width="7" height="7" /> 
    <rect x="13" y="28" rx="0" ry="0" width="6" height="8" /> 
    <rect x="162" y="69" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="69" rx="1" ry="1" width="87" height="8" /> 
    <rect x="162" y="28" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="28" rx="1" ry="1" width="87" height="8" /> 
    <rect x="0" y="22" rx="5" ry="5" width="400" height="1" /> 
    <rect x="13" y="48" rx="0" ry="0" width="6" height="8" /> 
    <rect x="16" y="49" rx="0" ry="0" width="7" height="7" /> 
    <rect x="0" y="62" rx="5" ry="5" width="400" height="1" /> 
    <rect x="28" y="48" rx="1" ry="1" width="87" height="8" /> 
    <rect x="162" y="48" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="48" rx="1" ry="1" width="87" height="8" /> 
    <rect x="0" y="1" rx="5" ry="5" width="400" height="1" /> 
    <rect x="0" y="84" rx="5" ry="5" width="400" height="1" /> 
    <rect x="7" y="8" rx="1" ry="1" width="107" height="8" /> 
    <rect x="162" y="8" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="8" rx="1" ry="1" width="87" height="8" /> -->
    <!-- loader with table header end -->

    <!-- loader without table header  -->
    <rect x="28" y="69" rx="1" ry="1" width="87" height="8" /> 
    <rect x="28" y="28" rx="1" ry="1" width="87" height="8" /> 
    <rect x="0" y="41" rx="5" ry="5" width="400" height="1" /> 
    <rect x="13" y="69" rx="0" ry="0" width="6" height="8" /> 
    <rect x="16" y="70" rx="0" ry="0" width="7" height="7" /> 
    <rect x="16" y="29" rx="0" ry="0" width="7" height="7" /> 
    <rect x="13" y="28" rx="0" ry="0" width="6" height="8" /> 
    <rect x="162" y="69" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="69" rx="1" ry="1" width="87" height="8" /> 
    <rect x="162" y="28" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="28" rx="1" ry="1" width="87" height="8" /> 
    <rect x="0" y="22" rx="5" ry="5" width="400" height="1" /> 
    <rect x="13" y="48" rx="0" ry="0" width="6" height="8" /> 
    <rect x="16" y="49" rx="0" ry="0" width="7" height="7" /> 
    <rect x="0" y="62" rx="5" ry="5" width="400" height="1" /> 
    <rect x="28" y="48" rx="1" ry="1" width="87" height="8" /> 
    <rect x="162" y="48" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="48" rx="1" ry="1" width="87" height="8" /> 
    <rect x="0" y="2" rx="5" ry="5" width="400" height="1" /> 
    <rect x="0" y="84" rx="5" ry="5" width="400" height="1" /> 
    <rect x="28" y="9" rx="1" ry="1" width="87" height="8" /> 
    <rect x="162" y="9" rx="1" ry="1" width="87" height="8" /> 
    <rect x="298" y="9" rx="1" ry="1" width="87" height="8" /> 
    <rect x="13" y="9" rx="0" ry="0" width="6" height="8" /> 
    <rect x="16" y="10" rx="0" ry="0" width="7" height="7" />
    <!-- / loader without table header -->
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "TableWithFolder",
    components: { ContentLoader }
};

</script>
